import type { NormalizedPoint } from '@peruselab/structure-editor/model';
import type { ReactionZone } from '@peruselab/structure-editor/domain/reactionGraph';
import type { DragPayload } from './dragDropModel';

/**
 * #700 -- where something added to the paper goes. `at` (paper-normalized) centres it there -- a
 * drop; `zone` puts it in that reaction box (dropped into it, or chosen from "Add to paper").
 * Neither: beside the drawing.
 */
export interface PaperPlacement {
  readonly at?: NormalizedPoint;
  readonly zone?: ReactionZone;
}

/**
 * #699/#700 -- a structure being dragged: a result card's molecule, a drawing (My drawings, or one
 * listed on a card) or an illustration. The source owns how it is added -- `place` runs the same
 * flow as its own "Add to paper" (stereoisomer choice, errors) -- so a target only says where.
 */
export interface StructureDragPayload extends DragPayload {
  readonly kind: 'structure';
  readonly place: (placement: PaperPlacement) => void;
}

export function isStructurePayload(payload: DragPayload): payload is StructureDragPayload {
  return payload.kind === 'structure' && typeof payload['place'] === 'function';
}
